export interface Service {
  id: number;
  name: string;
  description: string;
  price: string;
  image: string;
  category: 'men' | 'women' | 'kids';
  bookingLink: string;
}

export const services: Service[] = [
  // Existing services 1–9...

  // --- MEN'S ADDITIONAL SERVICES ---
  {
    id: 9,
    name: "Haircut",
    description: "Classic haircut tailored to your style and preferences.",
    price: "£15.00",
    image: "/assets/haircut.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 10,
    name: "Skin Fade",
    description: "High-contrast skin fade with sharp detailing.",
    price: "£15.00",
    image: "/assets/skin-fade.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 11,
    name: "Haircut and Shave",
    description: "Clean haircut and razor shave with hot towel finish.",
    price: "£20.00",
    image: "/assets/cut-shave.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 12,
    name: "Haircut and Wet Shave",
    description: "Precision haircut with traditional wet shave.",
    price: "£20.00",
    image: "/assets/haircut-wet-shave.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 13,
    name: "Shape Up",
    description: "Sharp line-up and edge definition for a clean look.",
    price: "£9.00",
    image: "/assets/shap-up.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 14,
    name: "Cornrows",
    description: "Traditional or modern cornrow styles tailored to you.",
    price: "£25.00",
    image: "/assets/cornrows.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 16,
    name: "Locs",
    description: "Starter or maintenance locs, styled and neat.",
    price: "£45.00",
    image: "/assets/locs.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 17,
    name: "Twists",
    description: "Two-strand or comb twists with natural texture.",
    price: "£35.00",
    image: "/assets/twists.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 18,
    name: "Afro Braids",
    description: "Protective afro braiding with creative designs.",
    price: "£30.00",
    image: "/assets/afro-braids.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 19,
    name: "Barrel Top Twists",
    description: "Detailed twist styles with barrel top technique.",
    price: "£40.00",
    image: "/assets/top-full-barrel.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },
  {
    id: 20,
    name: "Barrel Twist Full Head",
    description: "Full head barrel twists for a bold statement look.",
    price: "£50.00",
    image: "/assets/full-barrel.png",
    category: "men",
    bookingLink: "https://cal.com/3dsalon/men"
  },

  // --- WOMEN'S ADDITIONAL SERVICES ---
  {
    id: 21,
    name: "Wash, Hair Trim & Blow Dry",
    description: "Cleanse, trim, and professional blow dry for polished results.",
    price: "£35.00",
    image: "/assets/wash-dry-trim.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 22,
    name: "Wash & Blow Dry",
    description: "Rejuvenate your hair with a fresh wash and expert blow dry.",
    price: "£30.00",
    image: "/assets/wash.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 23,
    name: "Wash, Set & Tong",
    description: "Classic wash and set with tong curls for defined volume.",
    price: "£35.00",
    image: "/assets/set-tong.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 24,
    name: "Leave Out",
    description: "Traditional wash and roller set for elegant volume.",
    price: "£50.00",
    image: "/assets/wash-set.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 25,
    name: "Hair Trim",
    description: "Keep ends healthy with a professional trim.",
    price: "25.00",
    image: "/assets/trim.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 26,
    name: "Cornrow with Extensions",
    description: "Stylish cornrows enhanced with added extensions.",
    price: "From £45.00",
    image: "/assets/cornrow-exten.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 27,
    name: "Two Braids with Extensions",
    description: "Bold and elegant double braids with added length.",
    price: "£25.00",
    image: "/assets/two-braid.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 28,
    name: "Single Braid with Extensions",
    description: "Clean, single long braid enhanced with extensions.",
    price: "From £25.00",
    image: "/assets/single-braid.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 29,
    name: "Extension Track Per Line",
    description: "Per-track extension service, ideal for custom installs.",
    price: "From £75.00",
    image: "/assets/exten-track.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 30,
    name: "Relaxer Retouch",
    description: "Root retouching for chemically relaxed hair.",
    price: "£40.00",
    image: "/assets/relaxer.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 15,
    name: "Dutch Braid",
    description: "Weave style with natural hair left out for blending.",
    price: "£35.00",
    image: "/assets/wash-dry.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },
  {
    id: 32,
    name: "Braids knotless",
    description: "Natural-looking knotless braids for a seamless finish.",
    price: "Starting from £85.00",
    image: "/assets/braids-knotless.png",
    category: "women",
    bookingLink: "https://cal.com/3dsalon/woman"
  },

  // --- KIDS' ADDITIONAL SERVICES ---
  {
    id: 31,
    name: "Boys' Haircut",
    description: "Quick and clean haircut for boys aged 5–12.",
    price: "£10.00",
    image: "/assets/kids.png",
    category: "kids",
    bookingLink: "https://cal.com/3dsalon/kids"
  }
  
];
